import builder from '../builder';
import PictureStackLandscape from '../../streamline-icons/bold/picture-stack-landscape.svg';

export default builder('IconPictureStackLandscapeBold', PictureStackLandscape);
